import { makeTree } from "../../utils/utils";

export const formRequestBody = (state, customerSegmentData) => {
    const { segmentName, operator, attributes } = state;
    const customerSegmentQueryTreeIndividualNodes = attributes.map(item => {
        const attributeData = customerSegmentData.find(nestedItem => item.attribute === nestedItem.displayName)
        const operatorData = attributeData.operatorsAndValues.find(nestedItem => item.operator === nestedItem.displayName)
        let valueData = ""
        if (item.value instanceof Array) {
            valueData = {
                nodeType: "",
                valueKey: [],
                displayName: "",
            }
            const convertedArray = item.value.map((nestedItem, index) => {
                const obj = operatorData.values.valueList.find(doubleNestedItem => nestedItem === doubleNestedItem.displayName)
                valueData.valueKey[index] = obj.valueKey
                valueData.displayName += obj.displayName
                if (index < item.value.length - 1) {
                    valueData.displayName += ","
                }
                return obj
            })
            valueData.nodeType = convertedArray[0].nodeType
        } else {
            valueData = operatorData.values.valueList.find(nestedItem => item.value === nestedItem.displayName)
        }
        return {
            leftNode: {
                leftNode: null,
                nodeType: attributeData.nodeType,
                nodeValue: attributeData.attributeKey,
                nodeLabel: attributeData.displayName,
                rightNode: null
            },
            nodeType: operatorData.nodeType,
            nodeValue: operatorData.operatorKey,
            nodeLabel: operatorData.displayName,
            rightNode: {
                leftNode: null,
                nodeType: valueData.nodeType,
                nodeValue: valueData.valueKey,
                nodeLabel: valueData.displayName,
                rightNode: null
            },
        }
    })

    const ruleExpressionTree = { expressionNode: makeTree(customerSegmentQueryTreeIndividualNodes, operator) }

    return {
        segmentName,
        ruleExpressionTree,
        segmentType: "CUSTOMER"
    }

}